<script>
import WorkoutTabs from "../components/pages/create-update-workout/Tabs.vue";
import WarmupTabs from "../components/pages/create-update-warmup/Tabs.vue";
import StretchflowTabs from "../components/pages/create-update-stretch-flow/Tabs.vue";
import FileUpload from "../components/pages/create-update-workout/uploads/FileUpload.vue";

export default {
  name: "CreateWorkout",
  data() {
    return {
      type: false,
    };
  },
  components: {
    WorkoutTabs,
    WarmupTabs,
    FileUpload,
    StretchflowTabs,
  },
  computed: {
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  created() {
    this.$store.dispatch(`${this.currentType}/getFieldOptions`);
  },

  async mounted() {
    await this.$store.commit(`${this.currentType}/setEmptyActivity`);
    await this.$store.commit(`${this.currentType}/setEmptyPostProd`);
    if (this.$route) {
      if (this.$route.path == "/create-warmup") {
        this.type = "warmup-tabs";
      } else if (this.$route.path == "/create-workout") {
        this.type = "workout-tabs";
      } else if (this.$route.path == "/create-stretch-flow") {
        this.type = "stretchflow-tabs";
      }
    }
  },
};
</script>

<style scoped>
</style>

<template>
  <div>
    <component v-bind:is="type"></component>
    <file-upload></file-upload>
  </div>
</template>